import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { useInterview } from "hooks";
import { Grid, PageWrapper } from "components/Containers";
import PageTitle from "components/PageTitle";
import { InterviewPreview, InterviewQuestionsList } from "components/VideoPresentation";

/**
 * Video Presentation Setting
 */
const VideoPresentationSetting = () => {
  const { uuid } = useParams();
  const { data, loading } = useInterview({ uuid });

  return (
    <PageWrapper>
      <Helmet>
        <title>{data?.name}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle subtitle={data?.name} loading={loading} actionBar={<InterviewPreview interviewData={data} />} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <InterviewQuestionsList interviewData={data} loading={loading} />
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default VideoPresentationSetting;
